module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": false
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inn),
      expression: "inn"
    }]
  }, [_vm._v("\n        Полезные ссылки\n        "), _c('div', [_c('a', {
    attrs: {
      "href": 'https://atlant-smart.ru/services/entities/' + _vm.inn + '/excerpt?mode=redirect',
      "target": "_blank"
    }
  }, [_vm._v("Выписка из ЕГРЮЛ/ЕГРИП с ЭЦП ФНС РФ")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": 'https://bo.nalog.gov.ru/search?query=' + _vm.inn + '&page=1',
      "target": "_blank"
    }
  }, [_vm._v("Бухгалтерская отчетность")])]), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.open('https://kad.arbitr.ru')
      }
    }
  }, [_vm._v("Картотека арбитражных дел ")]), _c('br'), _vm._v("(ИНН копируется в буфер обмена)")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": 'https://fedresurs.ru/entities?searchString=' + _vm.inn,
      "target": "_blank"
    }
  }, [_vm._v("Федресурс (публикации существенных фактов)")])])])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffb10db8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/LinksPanel.vue
// module id = 1095
// module chunks = 1